import React from 'react';
import { Avatar, Button, Dropdown, Space } from 'antd';
import { useDispatch } from 'react-redux';
import { logOut } from '../../app/store/authSlice';
import { CaretDownOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface IProps {
  displayName: string;
}

const ProfileMenu: React.FC<IProps> = ({ displayName }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = (): void => {
    dispatch(logOut());
  };

  const handleChangePassword = (): void => {
    navigate('/change-password');
  };

  const items = [
    {
      key: 'password',
      label: (
        <Button type='link' size='small' onClick={handleChangePassword}>
          Change Password
        </Button>
      ),
    },
    {
      key: 'logout',
      label: (
        <Button type='link' size='small' danger onClick={handleLogout}>
          Log Out
        </Button>
      ),
    },
  ];

  return (
    <Dropdown menu={{ items }}>
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          <Avatar style={{ backgroundColor: '#0162b1' }}>
            <UserOutlined />
          </Avatar>
          {displayName}
          <CaretDownOutlined />
        </Space>
      </a>
    </Dropdown>
  );
};

export default ProfileMenu;
